import initializeTracking from "./tracking";

// Builds the preplay state
function buildVideoPlayer(element, videoData, autoplay) {

  var $element = $(element),
      blankElement = '<div></div>';

  var videoId = videoData.id,
      videoTitle = videoData.title,
      videoDescription = videoData.description,
      videoPreviewImage = videoData.preview,
      videoUrl = videoData.video,
      videoPlayerClass = videoData.theme === 'light' ? 'light-theme' : '';

  var $videoThumbnail = $('img', $element),
      $videoFooter = $(blankElement, {
        class: 'video-footer flexbox'
      }),
      $videoMetaContainer = $(blankElement, {
        class: 'video-meta flexbox-item'
      }),
      $videoTitle = $(blankElement, {
        class: 'video-title'
      }),
      $videoDescription = $(blankElement, {
        class: 'video-description'
      }),
      $videoPlayButtonContainer = $(blankElement, {
        class: 'video-play-button-container flexbox-item'
      }),
      $videoPlayButton = $('<i></i>', {
        class: 'video-play-button fa fa-play'
      });

  // Play button
  $videoPlayButtonContainer.append($videoPlayButton)
  $videoFooter.append($videoPlayButtonContainer)

  // Update video title
  $videoTitle.text(videoTitle)
  $videoMetaContainer.append($videoTitle)

  // Update video description
  $videoDescription.text(videoDescription)
  $videoMetaContainer.append($videoDescription)

  $videoFooter.append($videoMetaContainer);
  $element.append($videoFooter)
    .click(toggleToVideo)
    .addClass('can-toggle')
    .addClass(videoPlayerClass)
    .data(videoData);
}

// Interaction to switch to video player
function toggleToVideo() {
  var $this = $(this),
      isEmbedded = $this.parents('.article-content').length > 0;

  // Data (from memory)
  var videoId = $this.data('id'),
      videoRefId = 'vid-' + videoId,
      videoDescription = $this.data('description'),
      videoSrc = $this.data('video'),
      videoTitle = $this.data('title');

  // Video
  var $videoContainer = $('<div>', {}),
      $video = $('<video>', {
        id: videoRefId,
        class: 'video-js'
      }),
      $videoSrc = $('<source>')
        .attr('src', videoSrc);

  // Caption
  var $videoCaptionRow = $('<div>', {class: 'row'}),
      $videoCaptionCol = $('<div>', {class: 'col-md-12 col-sm-12 p0'}),
      $videoCaption = $('<div>', {class: 'video-caption mt2'}),
      $videoTitle = $('<div>', { class: 'video-title' })
        .text(videoTitle),
      $videoDescription = $('<div>', { class: 'video-description' })
        .text(videoDescription);

  $videoCaption.append($videoTitle)
  $videoCaption.append($videoDescription)
  $videoCaption.append($('<hr>'))
  $videoCaptionCol.append($videoCaption)
  $videoCaptionRow.append($videoCaptionCol)

  $video.append($videoSrc)
  $videoContainer.append($video)
  $this.unbind('click')
    .removeClass('can-toggle')
    .html($video)

  if (isEmbedded) {
    $this.append($videoCaption)
  } else {
    $this.append($videoCaptionRow)
  }

  var player = videojs(videoRefId, {
    controls: true,
    autoplay: true,
    preload: 'auto',
    fluid: true
  });

  initializeTracking(videoId, player);
}

export { buildVideoPlayer }
